export type Role = 'employee' | 'admin';
export type ReceiptStatus = 'pending' | 'approved' | 'rejected';

export interface User {
  id: number;
  email: string;
  name: string;
  role: Role;
}

export interface Receipt {
  id: number;
  user_id: number;
  user_name?: string;
  user_email?: string;
  receipt_type: string;
  document_no: string | null;
  company_name: string;
  receipt_date: string;
  amount_net: number;
  vat_rate: number;
  vat_amount: number;
  total_gross: number;
  status: ReceiptStatus;
  employee_note: string | null;
  admin_note: string | null;
  reviewed_at: string | null;
  created_at: string;
  image_url: string;
}

export interface AdminUser {
  id: number;
  email: string;
  name: string;
  role: Role;
  created_at: string;
  receipt_count: number;
  pending_count: number;
}

export const STATUS_LABEL: Record<ReceiptStatus, string> = {
  pending: 'Beklemede',
  approved: 'Onaylandı',
  rejected: 'Reddedildi',
};

export const STATUS_CLASS: Record<ReceiptStatus, string> = {
  pending: 'badge-pending',
  approved: 'badge-approved',
  rejected: 'badge-rejected',
};
